import { marketingAdministratorRoles } from "../config/roles";
import { audienceEntityOptions } from "../pages/communicationAudience/communicationAudienceRecord";
import { ListDefinition } from "./listDefinition.types";

const recordRoute = "/audience";

/**
 * The audiences list. Every audience comes back in one request, so its filters narrow
 * what is already loaded. The count is the last one saved, not a live one.
 */
export const communicationAudiencesListDefinition: ListDefinition = {
  path: "/audiences",
  entityName: "g4c_communicationaudience",
  recordRoute,
  title: "Audiences",
  allowedRoles: marketingAdministratorRoles,
  data: "all-at-once",
  filters: [
    {
      name: "Name",
      label: "Name",
      kind: "text",
      searchFields: ["Name"],
      width: "wider",
    },
    {
      name: "g4c_entitytype",
      label: "Regarding",
      kind: "picklist",
      options: audienceEntityOptions,
    },
    {
      name: "createdon",
      label: "Created",
      kind: "date-range",
      advanced: true,
    },
    {
      name: "modifiedon",
      label: "Modified",
      kind: "date-range",
      advanced: true,
    },
  ],
  filterByStatus: true,
  alphabetPagination: true,
  allowAdd: true,
  allowStatusEdit: true,
  columns: [
    {
      key: "Name",
      label: "Name",
      width: 420,
      sortable: true,
      link: { to: recordRoute, idKey: "Id", newTab: "button" },
    },
    {
      key: "g4c_entitytype",
      label: "Regarding",
      width: 200,
      display: "picklist",
      options: audienceEntityOptions,
      sortable: true,
    },
    {
      key: "g4c_lastcount",
      label: "Last Count",
      width: 200,
      display: "number",
      sortable: true,
    },
    {
      key: "g4c_lastcountedon",
      label: "Last Counted On",
      width: 200,
      display: "datetime",
      sortable: true,
    },
    {
      key: "createdon",
      label: "Created On",
      width: 200,
      display: "datetime",
      sortable: true,
    },
    {
      key: "modifiedon",
      label: "Modified On",
      width: 200,
      display: "datetime",
      sortable: true,
    },
  ],
};
